import { Inline } from '@etg/wings';
import { css } from '@eti/styles';
import SeatMapTravelerListItem from './SeatMapTravelerListItem';
import SingleTravelerButton from './SingleTravelerButton';
import { jsx as _jsx } from "react/jsx-runtime";
const travelerListStyles = css`
  min-height: 65px;
  overflow-x: auto;
  place-items: center;
`;
const inlineFlex = css`
  flex: 1;
`;
const SeatMapTravelersMobileTabs = ({
  activeSeatAssignments,
  activeSegment,
  activeTraveler,
  isRyanairInTrip,
  onChange,
  onRemoveSeat,
  seatTravelers,
  setTravelerButtonWithRemoveLink,
  travelerButtonWithRemoveLink
}) => {
  const isSingleTraveler = seatTravelers.length === 1;
  if (isSingleTraveler) {
    return /*#__PURE__*/_jsx(Inline, {
      className: inlineFlex,
      "data-testid": "seatMap-travelers-mobile-tabs",
      children: seatTravelers.map(traveler => /*#__PURE__*/_jsx(SingleTravelerButton, {
        activeSeatAssignments: activeSeatAssignments,
        activeSegment: activeSegment,
        activeTraveler: activeTraveler,
        isRyanairInTrip: isRyanairInTrip,
        isSingleTraveler: isSingleTraveler,
        onChange: onChange,
        onRemoveSeat: onRemoveSeat,
        setTravelerButtonWithRemoveLink: setTravelerButtonWithRemoveLink,
        traveler: traveler,
        travelerButtonWithRemoveLink: travelerButtonWithRemoveLink
      }, traveler.id))
    });
  }
  return /*#__PURE__*/_jsx(Inline, {
    noWrap: true,
    as: "ul",
    className: travelerListStyles,
    "data-testid": "seatMap-travelers-mobile-tabs",
    children: seatTravelers.map(traveler => /*#__PURE__*/_jsx(SeatMapTravelerListItem, {
      activeSeatAssignments: activeSeatAssignments,
      activeTraveler: activeTraveler,
      id: traveler.id,
      isRyanairInTrip: isRyanairInTrip,
      name: traveler.name || null,
      onChange: onChange,
      onRemoveSeat: () => onRemoveSeat(activeSegment, traveler.id),
      setTravelerButtonWithRemoveLink: setTravelerButtonWithRemoveLink,
      travelerButtonWithRemoveLink: travelerButtonWithRemoveLink
    }, traveler.id))
  });
};
export default SeatMapTravelersMobileTabs;
//# sourceMappingURL=SeatMapTravelersMobileTabs.js.map